import ServiceDetailPage from "./ServiceDetailPage";
import serviceContent from "./serviceContent";

const UIUXDesign = () => <ServiceDetailPage service={serviceContent.uiuxDesign} />;

export default UIUXDesign;
